module.exports = require("./lib/_stream_duplex.js")



/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/duplex.js
 ** module id = 1009
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/duplex.js
 ** module id = 1009
 ** module chunks = 1
 **/